import {createContext} from "react";

export const RegionContext = createContext({
    region: '',
    setRegion: (region) => {}
})
